import React from 'react'
import { Parser } from '../../common'
import LocalServiceDropdown from './LocalServiceDropdown'

const LocalService = ({ block, index }) => {
    return block.childrens ? (
        block.childrens.length > 1 ? (
            <LocalServiceDropdown blocks={block.childrens} id={block?.ID} />
        ) : (
            <div className="baseocom-local-service">
                <Parser content_block={block.childrens} />
            </div>
        )
    ) : null
}

export default LocalService
